import { expVal, expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

export const useCommentActionsVisibility = (isFabricPage?: boolean) => {
	const isNotFabricPage = isFabricPage === false;
	const areFeaturesEnabled =
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		fg('confluence_frontend_content_wrapper') &&
		expVal('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false);

	const isFabricPageWithFeaturesEnabled = isFabricPage && areFeaturesEnabled;

	// Determines whether to show the updated/modern comment actions UI
	// - If comments tuneup experiment is enabled: show for all pages except legacy (non-Fabric) pages
	// - If comments tuneup experiment is disabled: only show for Fabric pages with required features enabled
	const showMainActions = expValEquals('confluence_comments_tuneup', 'isEnabled', true)
		? !isNotFabricPage
		: isFabricPageWithFeaturesEnabled;

	// Determines whether to show the legacy/old comment actions UI
	// - If comments tuneup experiment is enabled: only show for legacy (non-Fabric) pages
	// - If comments tuneup experiment is disabled: show for all pages except Fabric pages with features enabled
	const showLegacyMainActions = expValEquals('confluence_comments_tuneup', 'isEnabled', true)
		? isNotFabricPage
		: !isFabricPageWithFeaturesEnabled;

	return { showMainActions, showLegacyMainActions };
};
